(() => {
  let form
  let messages

  /**
   * Permet l'affichage d'un message
   * @param type
   * @param content
   */
  function showMessage(type, content) {
    // Masquer tous les messages
    Object.values(messages).forEach((msg) => (msg.hidden = true));

    if (messages[type]) {
      // Créer le banner avec le contenu
      const bannerHTML = `
          <div class="banner banner--${type === 'success' ? 'success' : 'error'}">
            <div class="banner__content">
              <p class="text-sm">${content}</p>
            </div>
          </div>
        `;
      messages[type].innerHTML = bannerHTML;
      messages[type].hidden = false;
    }
  }

  /**
   * Affiche le loader
   */
  function showLoading() {
    Object.values(messages).forEach((msg) => (msg.hidden = true));
    messages.loading.hidden = false;
  }

  /**
   * Listener du submit du formulaire de demande de virement.
   * @param e
   * @returns {Promise<void>}
   */
  async function formEventListener(e) {
    e.preventDefault();

    const ibanInput = form.querySelector('[name="iban"]');
    const iban = ibanInput.value.trim();
    const userEmail = form.dataset.userEmail;
    const apiUrl = form.dataset.apiUrl;

    if (!iban || !userEmail) return;

    // Afficher le message de chargement
    showLoading();

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          iban: iban,
          userEmail: userEmail,
        }),
      });

      const data = await response.json();

      if (data.success) {
        showMessage('success', 'Transfert effectué avec succès');
        form.reset();
      } else {
        let errorMessage = 'Erreur lors de la soumission. Veuillez réessayer.';
        if (data.error?.message && typeof data.error.message === 'string') {
          errorMessage = data.error.message;
        }
        showMessage('error', errorMessage);
      }
    } catch (error) {
      console.error('Erreur lors de la soumission:', error);
      showMessage('error', 'Erreur de connexion au serveur. Veuillez réessayer.');
    } finally {
      if (ibanInput) {
        ibanInput.value = '';
      }
    }
  }

  async function loadWalletAmounts() {
    const userEmail = form.dataset.userEmail
    if (!userEmail) {
      return
    }
    const response = await fetch(`/apps/smala/wallet/amounts?user_email=${userEmail}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    });
    const data = await response.json();
    if (data.error) {
      throw new Error(data);
    } else {
      const credit = document.getElementById('credit-claim')
      credit.innerHTML = `${data.amountTransferable}€`
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    form = document.querySelector('[data-kapi-form]');
    if (!form) return;
    const messagesContainer = document.getElementById('kapi-messages');
    messages = {
      error: messagesContainer.querySelector('[data-status="error"]'),
      success: messagesContainer.querySelector('[data-status="success"]'),
      loading: messagesContainer.querySelector('[data-status="loading"]'),
    };
    form.addEventListener('submit', formEventListener)
    loadWalletAmounts().catch((error) => {
      showMessage('error', 'Erreur lors du chargement des informations clients');
      console.error(`Erreur lors du chargement des montantes : ${JSON.stringify(error)}`)
    })
  })
})();

